import {
  PLAYER_API_REQUEST,
  PLAYER_API_RECEIVE,
} from '../../constants'

export default function PlayerApiReducer(
  state = {},
  {
    type,
    path,
    response,
  } = {}
) {
  switch (type) {
    case PLAYER_API_REQUEST:
      return {
        ...state,
        [path]: {
          ...state[path],
          isFetching: true,
        },
      }

    case PLAYER_API_RECEIVE:
      return {
        ...state,
        [path]: {
          ...response,
          isFetching: false,
          receivedAt: Date.now(),
        },
      }

    default:
      return state
  }
}
